<template>
  <div class="form-quizz-question-item-component mb-3">
    <div class="d-flex align-items-center justify-content-bee">
      <button
        class="btn btn-sm btn-header p-0 m-0"
        @click.prevent="editing = !editing"
      >
        <div>
          <i
            v-if="isAllSaved"
            class="fa fa-grip-vertical handle lead fs-14"
          ></i>
        </div>
        <h6 class="m-0 p-0" :class="{ 'pl-6': editing }">
          {{ item.title }}
        </h6>
        <div class="d-flex"></div>
      </button>
      <div v-if="editing" class="d-flex align-items-center justify-content-end">
        <button
          type="button"
          class="btn btn-sm p-0"
          @click.prevent="onRemoveQuestion"
        >
          <i class="icon-filled-trash text-danger"></i>
        </button>
      </div>
    </div>
    <template v-if="editing">
      <hr />

      <form-group
        v-model="item.title"
        id="question"
        label=""
        placeholder="Digite a sua pergunta"
        class="mb-6"
        ultraSlim
      />

      <div class="mb-6">
        <h6 class="indicator-title mb-0 pb-2">Respostas</h6>
        <small class="indicator-description">
          Selecione abaixo a resposta correta.
        </small>
      </div>

      <div
        v-for="(alt, i) in valid_alternatives"
        :key="`alt-${i}`"
        class="d-flex align-items-center"
      >
        <b-form-radio
          v-model="right_answer"
          :id="`${alt.id}`"
          :value="`${alt.id}`"
          class="mr-2"
        />
        <form-group
          v-model="alt.title"
          ultraSlim
          :id="`alternative-${alt.id}`"
          :placeholder="`Opção de resposta ${i + 1}`"
          class="flex-fill"
        />
        <div class="remove-area">
          <button
            type="button"
            class="btn ml-3 p-0"
            @click="removeAlternative(i)"
          >
            <i class="icon-filled-trash text-danger"></i>
          </button>
        </div>
      </div>
      <button class="btn btn-add-alt" @click="addAlternatives">
        <i class="icon-plus mr-3"></i>
        <span>Clique para adicionar uma opção...</span>
      </button>

      <div class="d-flex justify-content-end mt-6 mb-3">
        <button
          v-if="form.id"
          type="button"
          class="btn btn-new-outline-primary btn-sm px-6 py-3"
          :disabled="!isValid"
          @click="submitSaveQuestion"
        >
          <b-spinner v-if="loading" variant="primary" small />
          <span v-else>Salvar</span>
        </button>
      </div>

      <confirmation
        iconType="warning"
        title="Aviso"
        cancelButtonText="Cancelar"
        v-model="dialog_remove"
        confirmButtonClass="btn-danger"
        confirmButtonText="Confirmar"
        :text="`Deseja mesmo excluir a pergunta: ${item.title}?`"
        @confirm="submitDeleteQuestion"
        @cancel="dialog_remove = false"
      />
    </template>
  </div>
</template>
<script>
import { get_error_msg, is_valid_br_date_str } from "@/functions/helpers";
import moment from "moment";

export default {
  props: {
    item: Object,
    form: Object,
    index: Number,
    isAllSaved: Boolean,
    isFinalQuiz: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.item?.id) {
      this.editing = true;
    }
  },
  data() {
    const alternative = this.item.answer_options.find(a => a.is_right_answer);
    const right_answer = alternative ? alternative.id : null;
    return {
      dialog_remove: false,
      right_answer,
      loading: false,
      editing: false
    };
  },
  watch: {
    right_answer(id) {
      this.item.answer_options = [
        ...this.item.answer_options.map(o => ({
          ...o,
          is_right_answer: id && id == o.id
        }))
      ];
    }
  },
  computed: {
    valid_alternatives() {
      return this.item.answer_options.filter(alt => !alt.deleted);
    },
    question_without_right_answer() {
      if (this.item.answer_options.length) {
        return this.item.answer_options
          .filter(a => !a.deleted)
          .reduce((acc, curr) => acc || curr.is_right_answer, false);
      }

      return true;
    },
    question_without_title() {
      if (this.item.answer_options.length) {
        return this.item.answer_options
          .filter(a => !a.deleted)
          .reduce((acc, curr) => acc || curr.title.length == 0, false);
      }

      return true;
    },
    isValid() {
      return this.item.title.length && this.item.answer_options.length;
    }
  },
  methods: {
    cancelEdit() {
      this.$emit("update");
      this.editing = false;
    },
    isDraft(alt) {
      return alt.id && `${alt.id}`.indexOf("local-alt") > -1;
    },
    onRemoveQuestion() {
      if (this.item.id) {
        this.dialog_remove = true;
      } else {
        this.$emit("remove", this.index);
      }
    },
    submitDeleteQuestion() {
      this.$emit("delete", this.index);
    },
    removeAlternative(alt_index) {
      if (this.isDraft(this.item.answer_options[alt_index])) {
        this.item.answer_options = [
          ...this.item.answer_options.filter((_, i) => i != alt_index)
        ];
      } else {
        const new_item = { ...this.item };
        new_item.answer_options[alt_index].deleted = true;
        this.item = new_item;
      }
    },
    addAlternatives() {
      this.item.answer_options = [
        ...this.item.answer_options,
        {
          id: `local-alt-${new Date().getTime().toString()}`,
          title: "",
          is_right_answer: false
        }
      ];
    },
    reAddLocalIds() {
      // workaround to fix ids when user get a error
      this.item.answer_options = [
        ...this.item.answer_options.map(a => {
          const n_option = {
            ...a,
            id: a.id || a.id_temp
          };
          delete n_option.id_temp;
          return n_option;
        })
      ];
      this.right_answer = this.item.answer_options.find(
        o => o.is_right_answer
      ).id;
    },
    build_payload(form) {
      const data = { ...form };
      for (let k in data.questions) {
        const alternatives = [...data.questions[k].answer_options];
        for (let i in alternatives) {
          if (
            alternatives[i].id &&
            `${alternatives[i].id}`.indexOf("local-alt") > -1
          ) {
            alternatives[i].id_temp = alternatives[i].id; // workaround to fix ids when user get a error
            delete alternatives[i].id;
          }
        }

        data.questions[k].answer_options = alternatives;
      }

      let release_at = form.release_at || null;
      if (form.release_at && form.release_at.length == 10) {
        release_at = moment(form.release_at, "DD/MM/YYYY").toISOString();
      }

      if (this.isFinalQuiz && Object.keys(data).includes("module_id")) {
        delete data.module_id;
      }

      return { ...data, release_at };
    },
    submitSaveQuestion() {
      if (this.loading) return;

      if (!this.item.title.length) {
        this.$message.warning(`Digite o título da pergunta ${this.index + 1}.`);
        return;
      }

      if (!this.item.answer_options.length) {
        this.$message.warning(
          `Por favor, adicione as alternativas da pergunta ${this.index + 1}.`
        );
        return;
      }

      if (
        this.form.release_at.length > 0 &&
        !is_valid_br_date_str(this.form.release_at)
      ) {
        this.$message.warning(
          "Digite uma data válida, maior que hoje para liberação da avaliação em uma data específica"
        );
        return;
      }

      if (!this.question_without_right_answer) {
        this.$message.warning(
          `Por favor, indique a resposta correta da pergunta ${this.index + 1}.`
        );
        return;
      }

      if (this.question_without_title) {
        this.$message.warning(
          `Por favor, verifique as alternativas, ainda há pelo menos uma alternativa sem texto.`
        );
        return;
      }

      const payload = this.build_payload({
        ...this.form,
        number_of_attempts: Number(this.form.number_of_attempts) + 1,
        product_id: this.$route.params.id
      });

      let action = this.isFinalQuiz
        ? "membersQuizzes/postFinal"
        : "membersQuizzes/post";

      if (payload.id) {
        action = this.isFinalQuiz
          ? "membersQuizzes/putFinal"
          : "membersQuizzes/put";
      }

      this.loading = true;
      this.$store
        .dispatch(
          action,
          this.isFinalQuiz
            ? {
                final_quiz: payload,
                product_id: this.$route.params.id,
                release_final_quiz_when_finished: this.form
                  .release_final_quiz_when_finished
              }
            : payload
        )
        .then(() => {
          this.$message.success(`A pergunta ${this.index + 1} foi salva!`);
          this.editing = false;
          this.$emit("update");
        })
        .catch(e => {
          const data = this.isFinalQuiz
            ? e.response.data.final_quiz
            : e.response.data;

          let msg = get_error_msg(
            data,
            "TRANSLATE_FIELD_QUIZZ_MAP",
            `Não foi possível salvar a pergunta ${this.index + 1}!`,
            `Verifique a lista de questões - `
          );

          this.$message.error(msg);

          this.reAddLocalIds();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-quizz-question-item-component {
  border-radius: 4px;
  border: 1px solid var(--l-neutral-113, rgba(219, 221, 230, 0.85));
  background: var(--l-elevation-12, rgba(255, 255, 255, 0.48));
  padding: 16px 24px;
  transition: 0.3s border;

  &:hover {
    border: 1px solid rgba(207, 174, 255, 0.86);
  }

  .btn-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 20px;
    .fa-grip-vertical {
      color: #9b9db0db;
    }

    h6 {
      color: var(--l-neutral-105, rgba(38, 36, 50, 0.93));
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .btn-add-alt {
    padding: 0 !important;
    margin: 5px 0 !important;
    width: 100%;
    i {
      font-size: 18px;
      color: rgba(120, 30, 255, 0.88);
    }

    span {
      color: var(--l-neutral-2, rgba(155, 157, 176, 0.86));
      font-size: 14px;
      font-style: normal;
      text-align: left;
      font-weight: 400;
      border-radius: 4px;
      border: 1px solid var(--l-neutral-2, rgba(155, 157, 176, 0.86));
      background: rgba(219, 221, 230, 0.2);
      display: block;
      width: 100%;
      padding: 8px 12px;
      margin-right: 31px;
    }
  }

  .icon-drag-indicator {
    color: #9b9db0db;
    font-size: 18px;
  }

  .icon-filled-trash {
    font-size: 24px;
    width: 22px;
    line-height: 16px;
  }

  .lead {
    cursor: grab;
  }

  small {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  ::v-deep .form-control:disabled {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #00b837;
    background-color: #00b837;
  }
}
</style>
